export const NOTIFICATION_MESSAGES = {
  //SOA
  SOA_DOWNLOAD_SUCCESS: "Successfully downloaded SOA sheet for {0}",
  SOA_DOWNLOAD_ERROR: "Failed to download SOA sheet",
  SOA_SEND_EMAIL_SUCCESS: "Successfully sent email to {0}",
  SOA_SEND_EMAIL_ERROR: "Failed to send SOA sheet",

  //Auth
  FORGOT_PASSWORD_SUCCESS:
    "Reset password email has been sent. Please check your inbox",
  RESET_PASSWORD_SUCCESS: "Password Resets Successfully",

  //Profile
  CHANGE_PASSWORD_SUCCESS: "Password Changed Successfully",
  CHANGE_NUMBER_SUCCESS: "Number Changed Successfully",

  //Financial Profile
  LINKED_FINANCIAL_PROFILE_SUCCESS: "Financial profile successfully linked",
  UNLINKED_FINANCIAL_PROFILE_SUCCESS: "Financial profile successfully unlinked",

  //Organization
  ORGANIZATION_CREATE_SUCCESS: "Organization created successfully",
  ORGANIZATION_UPDATE_SUCCESS: "Organization updated successfully",
  ORGANIZATION_STATUS_UPDATE_SUCCESS: "Organization {0} successfully",
  ORGANIZATION_UPDATE_PREFERENCE_SUCCESS:
    "Organization preferences updated successfully",
  ORGANIZATION_NOT_FOUND: "Organization not found",

  //Manage Pricing
  PRICING_CREATE_SUCCESS: "Pricing created successfully",
  PRICING_UPDATE_SUCCESS: "Pricing updated successfully",
  //Permissions
  UPDATE_PERMISSIONS_SUCCESS: "Permissions updated successfully",

  // Agent
  ADD_AGENT_SUCCESS: "{0} added successfully in the organization",
  UPDATE_AGENT_SUCCESS: "{0} updated successfully in the organization",
  AGENT_DELETE_SUCCESS: "User deleted successfully from the organization",

  //Others
  INVALID_EMAIL: "Email is invalid",
  DEFAULT: "Something went wrong. Please try again.",
  SOMETHING_WENT_WRONG:
    "Something went wrong. Please try again. If the problem persists, contact support.",
  NO_RESULTS_FOUND: "No results found",
  NO_RESULTS_FOUND_DESCRIPTION:
    "Uh-oh! It seems like there are no records that match your selected filter",
  INVALID_DATE: "Invalid date",

  //Payments
  CC_CHARGES_DEDUCTION:
    "{0}% charges will be deducted incase of credit/debit card.",
  ONE_BILL_CHARGES_DEDUCTION:
    "PKR {0} charges will be deducted incase of one bill.",
  TOTAL_AMOUNT_DEPOSIT: "Total {1} {0} will be deposited in your account",
  PAYMENT_CREATE_SUCCESS: "Payment created successfully",
  IBFT_DEDUCTION:
    "Your payment will be reflected in your AeroGlobe account balance within 30 minute",
  //My Bookings
  BRAND_TICKET_DOWNLOAD_SUCCESS: "Ticket downloaded successfully",
  AIRLINE_TICKETS_SENT_SUCCESS:
    "Tickets sent successfully to provided email addresses.",

  //Tour
  SELECT_ANY_PACKAGE: "Please select any package",
  FDG_FLIGHTS_CONFIRM_BOOKING_SUCCESS:
    "Your request of tour has been recieved, you will be contacted through email shortly.",
  FDG_FLIGHTS_OTP_SENT_TO_EMAIL_SUCCESS: "OTP is sent to your email address.",
  FDG_FLIGHTS_PAY_NOW_SUCCESS: "Great! your payment has been received",
  FDG_FLIGHTS_CANCEL_SUCCESS: "Booking Successfully Canceled",
  FDG_FLIGHTS_PASSENGER_UPDATE_SUCCESS: "Passengers updated successfully",

  //  Credit Limit Requests
  CREATE_CREDIT_LIMIT_REQUEST_SUCCESS:
    "Request for temporary credit limit has been created successfully and sent to the concerned person for review",
  APPROVE_CREDIT_LIMIT_REQUEST_SUCCESS:
    "Approve credit limit request successfully",
  REJECT_CREDIT_LIMIT_REQUEST_SUCCESS:
    "Reject credit limit request successfully",
  UNLINK_FINANCIAL_PROFILE_SUCCESS: "Unlink financial profile successfully",
  HOTEL_FREE_CANCELLATION_MESSAGE:
    "Cancellation is Free - Issue now and pay later",
  HOTEL_FREE_CANCELLATION_DESCRIPTION:
    "Secure your booking with ease - Payment will be automatically deducted on {0} at {1}",
  HOTEL_BOOKING_CANCEL_SUCCESS: "Hotel booking cancelled successfully",
  HOTEL_BOOKING_PAYMENT_SUCCESS: "Successfully paid for the booking",

  // Quotation Surcharge
  APPLY_SURCHARGE_SUCCESS: "Surcharge applied successfully",
  APPLY_SURCHARGE_FAILURE: "Failed to apply surcharge",

  // Employee Grade
  EMPLOYEE_GRADE_CREATE_SUCCESS: "Employee Grade created successfully",
  EMPLOYEE_GRADE_UPDATE_SUCCESS: "Employee Grade updated successfully",
  EMPLOYEE_GRADE_DELETE_SUCCESS: "Employee Grade deleted successfully",
  EMPLOYEE_GRADE_STATUS_UPDATE_SUCCESS: "{0} set to {1} successfully",

  // Travel Policy
  TRAVEL_POLICY_CREATE_SUCCESS: "Travel policy created successfully",
  TRAVEL_POLICY_UPDATE_SUCCESS: "Travel policy updated successfully",
  TRAVEL_POLICY_DELETE_SUCCESS: "Travel policy deleted successfully",
  TRAVEL_POLICY_STATUS_UPDATE_SUCCESS: "{0} set to {1} successfully",
  TRAVEL_POLICY_RULES_CREATE_SUCCESS: "Travel policy rules saved successfully",
  TRAVEL_POLICY_RULES_UPDATE_SUCCESS:
    "Travel policy rules updated successfully",

  //Corporate Policy
  CORPORATE_POLICY_CREATE_SUCCESS: "Corporate policy created successfully",
  CORPORATE_POLICY_UPDATE_SUCCESS: "Corporate policy updated successfully",
  CORPORATE_POLICY_DELETE_SUCCESS: "Corporate policy deleted successfully",
  CORPORATE_POLICY_STATUS_UPDATE_SUCCESS:
    "Corporate policy {0} status updated to {1} successfully",
  CORPORATE_POLICY_RULES_CREATE_SUCCESS:
    "Corporate policy rules saved successfully",
  CORPORATE_POLICY_RULES_UPDATE_SUCCESS:
    "Corporate policy rules updated successfully",
  CORPORATE_POLICY_RULES_DELETE_SUCCESS:
    "Corporate policy rules deleted successfully",
  CORPORATE_POLICY_RULES_STATUS_UPDATE_SUCCESS:
    "Corporate policy rules {0} set to {1} successfully",

  // Cost Center
  COST_CENTER_CREATE_SUCCESS: "Cost Center created successfully",
  COST_CENTER_UPDATE_SUCCESS: "Cost Center updated successfully",
  COST_CENTER_DELETE_SUCCESS: "Cost Center deleted successfully",
  COST_CENTER_STATUS_UPDATE_SUCCESS: "{0} set to {1} successfully",

  // Department
  DEPARTMENT_CREATE_SUCCESS: "Department created successfully",
  DEPARTMENT_UPDATE_SUCCESS: "Department updated successfully",
  DEPARTMENT_DELETE_SUCCESS: "Department deleted successfully",
  DEPARTMENT_STATUS_UPDATE_SUCCESS: "{0} set to {1} successfully",

  // Approval Workflow
  APPROVAL_WORKFLOW_CREATE_SUCCESS: "Approval workflow created successfully",
  APPROVAL_WORKFLOW_UPDATE_SUCCESS: "Approval workflow updated successfully",
  APPROVAL_WORKFLOW_DELETE_SUCCESS: "Approval workflow deleted successfully",
  APPROVAL_WORKFLOW_STATUS_UPDATE_SUCCESS: "{0} set to {1} successfully",

  // Approval Requests
  APPROVAL_REQUEST_ACTION_SUCCESS: "Approval request updated successfully",
  APPROVAL_REQUEST_OVERRIDE_SUCCESS: "Approval request overridden successfully",
  APPROVAL_REQUEST_CANCEL_SUCCESS: "Approval request cancelled successfully",

  // Bulk Assignment
  BULK_ASSIGNMENT_EMPLOYEES_REASSIGNED_SUCCESS:
    "{0} employee(s) reassigned successfully",
  BULK_ASSIGNMENT_ALL_EMPLOYEES_REASSIGNED_SUCCESS:
    "All employees have been reassigned.",
  BULK_ASSIGNMENT_EMPLOYEES_FETCH_ERROR:
    "Failed to load employees. Please try again.",
  BULK_ASSIGNMENT_OPTIONS_FETCH_ERROR:
    "Failed to load assignment options. Please try again.",
};
